export default "__VITE_ASSET__ED8wZFVy__"